import { InjectionToken } from "@angular/core";

export interface AppEnvironment {
	production: boolean;
	url: string;
	redirect: string;
	logLevel: string;
	demo: boolean;
	logoutRedirectUrl: string;
	staging: boolean;
	/** URL of the new NestJS portal-backend */
	portalBackendUrl?: string;
	/** API key for the NestJS portal-backend */
	portalApiKey?: string;
	/** Git commit hash injected at build time, used for Sentry release matching */
	version?: string;
	/** Build configuration name (production, forvia, internal, etc.), used for Sentry release scoping */
	buildConfig?: string;
	/** Feature flag: enables the traps module (routing + navigation). */
	trapsEnabled?: boolean;
}

export const ENV_CONFIG = new InjectionToken<AppEnvironment>("ENV_CONFIG");
